import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f7fbf77"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"10px"} }, null, -1))
const _hoisted_2 = { class: "edit-block" }
const _hoisted_3 = { class: "ai-labels" }
const _hoisted_4 = { class: "material-input" }
const _hoisted_5 = {
  key: 0,
  style: {"text-align":"center","padding":"3px"}
}
const _hoisted_6 = {
  key: 0,
  class: "turn"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1637649879614",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2501",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 74.666667c-17.066667 0-32 14.933333-32 32v149.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32V106.666667c0-17.066667-14.933333-32-32-32zM693.333333 362.666667c8.533333 0 17.066667-2.133333 23.466667-8.533334l104.533333-104.533333c12.8-12.8 12.8-32 0-44.8-12.8-12.8-32-12.8-44.8 0l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 4.266667 6.4 12.8 8.533333 21.333333 8.533334zM917.333333 480h-149.333333c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h149.333333c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32zM714.666667 669.866667c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8l104.533333 104.533333c6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333c12.8-12.8 12.8-32 0-44.8l-106.666666-104.533333zM512 736c-17.066667 0-32 14.933333-32 32v149.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-149.333333c0-17.066667-14.933333-32-32-32zM309.333333 669.866667l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333l104.533334-104.533333c12.8-12.8 12.8-32 0-44.8s-36.266667-12.8-46.933334 0zM288 512c0-17.066667-14.933333-32-32-32H106.666667c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h149.333333c17.066667 0 32-14.933333 32-32zM247.466667 202.666667c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l104.533333 104.533333c6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333c12.8-12.8 12.8-32 0-44.8l-106.666666-104.533333z",
    "p-id": "2502",
    fill: "#8a8a8a"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { "element-loading-text": "AI 文案生成中..." }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"60px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ai_labels = _resolveComponent("ai-labels")!
  const _component_user_detail = _resolveComponent("user-detail")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_rich_editor = _resolveComponent("rich-editor")!
  const _component_editor_toolbar = _resolveComponent("editor-toolbar")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ai_labels, {
            aiLabel: _ctx.aiLabelList,
            isSpread: !_ctx.isShowAiLabel,
            userMsg: _ctx.aiPlasticParam,
            onChangeLabel: _ctx.changeAiText,
            onChangeLabelType: _ctx.getLabelType,
            onChangeAiPlastic: _ctx.addAiPlasticText
          }, null, 8, ["aiLabel", "isSpread", "userMsg", "onChangeLabel", "onChangeLabelType", "onChangeAiPlastic"])
        ]),
        _createVNode(_component_user_detail, {
          orderIdProp: _ctx.orderId,
          isWorkbenchProp: _ctx.isWorkbench,
          onPicUpdate: _ctx.picUpdate,
          onGetUserFacePic: _ctx.getUserOriginFace
        }, null, 8, ["orderIdProp", "isWorkbenchProp", "onPicUpdate", "onGetUserFacePic"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isWorkbench)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.orderUser.name) + "的看脸报告 ", 1),
                (_ctx.autosaveLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.mouldTitle,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.mouldTitle) = $event)),
                  placeholder: "请输入模板名称",
                  maxlength: "25",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]))
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          _createVNode(_component_rich_editor, {
            isWorkbenchProp: _ctx.isWorkbench,
            contentProp: _ctx.content,
            onSaveMaterial: _ctx.save,
            onSaveOrderContent: _ctx.saveOrder,
            onChangeOrderType: _ctx.changeOrderStatus,
            onExportPdf: _ctx.exportPdf
          }, null, 8, ["isWorkbenchProp", "contentProp", "onSaveMaterial", "onSaveOrderContent", "onChangeOrderType", "onExportPdf"])
        ], 512), [
          [_directive_loading, _ctx.aiLoading]
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_editor_toolbar, {
          isWorkbenchProp: _ctx.isWorkbench,
          bgColorProp: _ctx.colorContent,
          relatedMsgProp: _ctx.orderUser.relatedMsg,
          onGetColorSetting: _ctx.getColor
        }, null, 8, ["isWorkbenchProp", "bgColorProp", "relatedMsgProp", "onGetColorSetting"])
      ])
    ]),
    _hoisted_11
  ], 64))
}